module.exports = __webpack_public_path__ + "static/media/splash.7d0e6278.jpg";